export const LifetimeType = {
    SINGLETON: Symbol.for('singleton'),
    TRANSIENT: Symbol.for('transient')
};

export const ContainerValueType = {
    FACTORY: Symbol('factory'),
    CONSTRUCTOR: Symbol('ctor'),
    CONSTANT: Symbol('constant')
};
